<template>
     <div class="formulario-contacto obras">
          <mapa></mapa>

         <div class="container">
             <h2 class="text-center">Presupuestos</h2>


            <form id="my_form" v-if="formulario_activo" @submit.prevent="handleSubmit" enctype="multipart/form-data" >
            <div class="form-row">
                <div class="form-group col-sm-12 col-md-6">
                <label for="inputEmail4">NOMBRE Y APELLIDO:</label>
                <input type="text" class="form-control" id="name" placeholder="Nombre y Apellido" required v-model="name">
                </div>
                <div class="form-group  mt-md-0 col-sm-12 col-md-6">
                <label for="inputEmail4">Email:</label>
                <input id="email" class="form-control" placeholder="Email" type="email" required v-model="email">
                </div>

            </div>

            <div class="form-row">

                <div class="form-group col-sm-12 col-md-6">
                    <label for="inputEmail4">TELEFONO:</label>
                    <input type="text" class="form-control" id="subject" placeholder="Telefono" required v-model="phone">
                </div>
                  <div class="form-group col-sm-12 col-md-6">
                    <label for="inputEmail4">DIMENSIONES DEL LOCAL O M2:</label>
                    <input type="text" class="form-control" id="dimensiones" placeholder="Dimensiones" required v-model="dimensiones">
                </div>


            </div>
            <div class="form-row">

                    <div class="form-group  col-sm-12 col-md-12">
                      <label for="inputEmail4">NECESITO PRESUPUESTO DE:</label>
                      <textarea id="message" required v-model="message" class="form-control" rows="2"></textarea>
                  </div>
            </div>
             <h2>Fotos de su local: de 4 a 8 fotos</h2>
            <div class="form-row">

                        <div class="form-group col-sm-12 col-md-6">
                            <label for="inputEmail4">Imagen Local 1:</label>
                            <input type="file" class="form-control" id="file" ref="file" v-on:change="handleFileUpload()" placeholder="Imagen Local">
                        </div>
                          <div class="form-group col-sm-12 col-md-6">
                            <label for="inputEmail4">Imagen Local 2:</label>
                            <input type="file" class="form-control" id="file2" ref="file2" v-on:change="handleFileUpload2()" placeholder="Imagen Local 2">
                        </div>
                          <div class="form-group col-sm-12 col-md-6">
                            <label for="inputEmail4">Imagen Local 3:</label>
                            <input type="file" class="form-control" id="file3" ref="file3" v-on:change="handleFileUpload3()" placeholder="Imagen Local 3">
                          </div>
                          <div class="form-group col-sm-12 col-md-6">
                            <label for="inputEmail4">Imagen Local 4:</label>
                            <input type="file" class="form-control" id="file4" ref="file4" v-on:change="handleFileUpload4()" placeholder="Imagen Local 4">
                          </div>
                          <div class="form-group col-sm-12 col-md-6">
                            <label for="inputfile5">Imagen Local 5:</label>
                            <input type="file" class="form-control" id="file5" ref="file5" v-on:change="handleFileUpload5()" placeholder="Imagen Local 5">
                          </div>
                          <div class="form-group col-sm-12 col-md-6">
                            <label for="inputfile5">Imagen Local 6:</label>
                            <input type="file" class="form-control" id="file6" ref="file6" v-on:change="handleFileUpload6()" placeholder="Imagen Local 6">
                          </div>
                            <div class="form-group col-sm-12 col-md-6">
                            <label for="inputfile7">Imagen Local 7:</label>
                            <input type="file" class="form-control" id="file7" ref="file7" v-on:change="handleFileUpload7()" placeholder="Imagen Local 7">
                          </div>
                            <div class="form-group col-sm-12 col-md-6">
                            <label for="inputfile8">Imagen Local 8:</label>
                            <input type="file" class="form-control" id="file8" ref="file8" v-on:change="handleFileUpload8()" placeholder="Imagen Local 8">
                          </div>
            </div>

           <vue-recaptcha ref="recaptcha" @verify="onVerify" sitekey="6Lfnj2kUAAAAAENt6qI6L7PYXK9Sb9QBudvKYFwc"></vue-recaptcha>

            <button type="submit" class="btn btn-primary form-group mt-2" :disabled="boton_submit == false">Enviar</button>
            </form>

            <div class="gracias" v-else>Gracias!! Estaremos en contacto.</div>
            <div class="caja-carga pb-5">
                  <h2 v-if="uploadPercentage > 0">{{uploadPercentage}}%</h2>
                <!-- upload bar -->
                <div class="progress" v-if="uploadPercentage > 0">
                    <div  class="progress-bar progress-bar-striped" role="progressbar" :style="`width: ${uploadPercentage}%`" :aria-valuenow="uploadPercentage" aria-valuemin="0" aria-valuemax="100"></div>
                </div>
            </div>

        </div>
    </div>

</template>
     <script>
     import Mapa from './Datos_mapa'
     import VueRecaptcha from 'vue-recaptcha';
     import axios from 'axios';
      export default {
        components: { VueRecaptcha, mapa:Mapa },
        data(){
          return{
            formulario_activo:true,
            name:'',
            email:'',
            phone:'',
            subject:'',
            dimensiones:'',
            message:'',
            file:'',
            file2:'',
            file3:'',
            file4:'',
            file5:'',
            file6:'',
            file7:'',
            file8:'',
            response:'',
            boton_submit:false,
            uploadPercentage: 0
          }
        },
        methods:{
          onVerify: function (response) {
            this.response = response;
            this.boton_submit = true;
          },
           handleFileUpload(){
                                         //    3rmb
               if(this.$refs.file.files[0] > 3000000){
                   alert("Imagen muy pesada");
                   this.file = ''
               }else{
                    this.file = this.$refs.file.files[0];
               }

           },
           handleFileUpload2(){
             this.file2 = this.$refs.file2.files[0];
           },
           handleFileUpload3(){
             this.file3 = this.$refs.file3.files[0];
           },
             handleFileUpload4(){
             this.file4 = this.$refs.file4.files[0];
           },
            handleFileUpload5(){
             this.file5 = this.$refs.file5.files[0];
           },
            handleFileUpload6(){
             this.file6 = this.$refs.file6.files[0];
           },
            handleFileUpload7(){
             this.file7 = this.$refs.file7.files[0];
           },
            handleFileUpload8(){
             this.file8 = this.$refs.file8.files[0];
           },
          handleSubmit(){
            var that = this;
            let formdata = new FormData();
            formdata.append( "template-contactform-name", this.name );
            formdata.append( "template-contactform-email", this.email );
            formdata.append( "template-contactform-phone", this.phone );
            formdata.append( "template-contactform-dimensiones", this.dimensiones );
            formdata.append( "template-contactform-subject", `Pedido de presupuesto de: ${this.name}`);
            formdata.append( "template-contactform-message", this.message );
            formdata.append( "template-contactform-file", this.file);
            formdata.append( "template-contactform-file2", this.file2);
            formdata.append( "template-contactform-file3", this.file3);
            formdata.append( "template-contactform-file4", this.file4);
            formdata.append( "template-contactform-file5", this.file5);
            formdata.append( "template-contactform-file6", this.file6);
            formdata.append( "template-contactform-file7", this.file7);
            formdata.append( "template-contactform-file8", this.file8);
            formdata.append( "g-recaptcha-response", this.response );
            formdata.append( "template-contactform-submit", "submit" );

           axios.post( '/pform/include/presupuesto.php',
                formdata,
                {
                  headers: {
                      'Content-Type': 'multipart/form-data'
                  },
                  onUploadProgress: function( progressEvent ) {
                        this.uploadPercentage = parseInt( Math.round( ( progressEvent.loaded * 100 ) / progressEvent.total ) );
                    }.bind(this)
                }
              ).then(function(){
                that.formulario_activo = false;
                console.log('SUCCESS!!');
              })
              .catch(error => {
                console.log(error)
              });


          }
        }
      }

          </script>

<style>
  .gracias{
      text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/contacto/Presupuesto.vue